<template>
    <v-card flat class="pa-5">
        <v-dialog v-model="novoModelo">
            <v-card class="pa-3">

                <v-layout row justify-space-around wrap>

                    <v-flex xs5 class="ml-2 mr-2">

                        <h3 class="fonte text-uppercase mt-2">Campos</h3>
                        <div class="ma-3">
                            <h3>Deseja salvar como seu template padrão?</h3>
                            <v-switch color="teal" v-model="isDefault" :label="isDefault ? 'Sim' : 'Não'"></v-switch>
                            <v-text-field color="teal" box v-model="template.type" v-if="isDefault === false" label="Defina o tipo do seu Template"></v-text-field>
                            <h3>Nome do Template</h3>
                            <v-text-field v-model="template.nome" label="Digite o nome do template" color="teal" box></v-text-field>
                            <h3>Barra Superior</h3>
                            <v-text-field class="mb-3" box v-model="template.template.head.logo" color="teal" label="Cole o endereço de outra imagem para a logo do menu"></v-text-field>
                            <v-text-field class="mb-3" box v-model="template.template.head.titulo" color="teal" label="Digite o Título"></v-text-field>
                            <h3>Conteúdo</h3>
                            <v-text-field class="mb-3" box v-model="template.template.body.logo.src" color="teal" label="Cole o endereço de outra imagem para a logo"></v-text-field>
                            <v-textarea class="mb-3" box label="Digite seu texto" color="teal" v-model="template.template.body.texto" persistent-hint hint="Favor utilizar pontuação de forma correta para manter o layout."></v-textarea>
                            <h3>Botão de Acesso</h3>
                            <h4>Deseja incluir?</h4>
                            <v-switch v-model="template.template.body.botao.selecionaBtn" :label="template.template.body.botao.selecionaBtn == true ? 'Sim' : 'Não'" color="teal"></v-switch>
                            <h4 v-if="template.template.body.botao.selecionaBtn">Deseja incluir mais de um link? (exemplo: para abrir em um Android ou em um iPhone)</h4>
                            <v-switch v-if="template.template.body.botao.selecionaBtn" v-model="template.template.body.botao.selecionaMultiLink" :label="template.template.body.botao.selecionaMultiLink == true ? 'Sim' : 'Não'" color="teal"></v-switch>
                            <div v-if="template.template.body.botao.selecionaBtn && !template.template.body.botao.selecionaMultiLink">
                                <v-text-field v-model="template.template.body.botao.link" color="teal" box label="Link geral"></v-text-field>
                            </div>
                            <div v-if="template.template.body.botao.selecionaBtn && template.template.body.botao.selecionaMultiLink">
                                <v-text-field v-model="template.template.body.botao.links.linkAndroid" color="teal" box label="Link para Android"></v-text-field>
                                <v-text-field v-model="template.template.body.botao.links.linkIphone" color="teal" box label="Link para iOS (iPhone)"></v-text-field>
                                <v-text-field v-model="template.template.body.botao.links.linkPc" color="teal" box label="Link geral"></v-text-field>
                            </div>
                            <v-text-field class="mb-3" box v-model="template.template.footer.contato" color="teal" label="Digite o texto do rodapé"></v-text-field>
                            <h3>Botões de redes sociais</h3>
                            <v-switch color="teal" v-model="template.template.body.redes.whatsapp.selecionado" label="Incluir WhatsApp"></v-switch>
                            <v-text-field box v-if="template.template.body.redes.whatsapp.selecionado" mask="(##)#####-####" v-model="template.template.body.redes.whatsapp.placeholder" class="pl-4" label="Digite seu telefone"></v-text-field>
                            <v-switch color="teal" v-model="template.template.body.redes.dialer.selecionado" label="Incluir Discador"></v-switch>
                            <v-text-field box v-if="template.template.body.redes.dialer.selecionado" mask="(##)#####-####" v-model="template.template.body.redes.dialer.placeholder" class="pl-4" label="Digite seu telefone"></v-text-field>
                            <v-switch color="teal" v-model="template.template.body.redes.facebook.selecionado" label="Incluir Facebook"></v-switch>
                            <v-text-field box v-if="template.template.body.redes.facebook.selecionado" class="pl-4" label="Digite o endereço de sua página" v-model="template.template.body.redes.facebook.placeholder"></v-text-field>
                            <v-switch color="teal" v-model="template.template.body.redes.email.selecionado" label="Incluir E-mail"></v-switch>
                            <v-text-field box v-if="template.template.body.redes.email.selecionado" class="pl-4" label="Digite seu e-mail" v-model="template.template.body.redes.email.placeholder"></v-text-field>
                        </div>
                        <v-btn class="ml-4" round large color="fundo" @click="cadastraTemplate">Cadastrar Layout</v-btn>
                    </v-flex>
                    <v-flex xs4>
                        <h3 class="fonte text-uppercase pt-2">Template</h3>
                        <v-card class="ma-3" width="450">
                            <div
                                is="layout"
                                style="height: 800px; overflow: auto;"
                                :head.sync="template.template.head"
                                :body.sync="template.template.body"
                                :footer.sync="template.template.footer"
                            ></div>
                        </v-card>
                    </v-flex>

                </v-layout>
            </v-card>
        </v-dialog>

        <v-dialog v-model="editTemplate">
            <v-card class="pa-3" v-if="Object.keys(templateSelected.template).length > 0">
                <v-layout row justify-space-around wrap>
                    <v-flex xs5 class="ml-2 mr-2">
                        <h3 class="fonte text-uppercase mt-2">Campos</h3>
                        <div class="ma-3">
                            <h3>Deseja alterar para seu template padrão?</h3>
                            <v-switch color="teal" v-model="templateSelected.isDefault" :label="templateSelected.type ? 'Sim' : 'Não'"></v-switch>
                            <v-text-field color="teal" box v-model="templateSelected.type" v-if="!templateSelected.isDefault" label="Defina o tipo do seu Template"></v-text-field>
                            <h3>Nome do Template</h3>
                            <v-text-field v-model="templateSelected.nome" label="Digite o nome do template" color="teal" box></v-text-field>
                            <h3>Barra Superior</h3>
                            <v-text-field class="mb-3" box v-model="templateSelected.template.head.logo" color="teal" label="Cole o endereço de outra imagem para a logo do menu"></v-text-field>
                            <v-text-field class="mb-3" box v-model="templateSelected.template.head.titulo" color="teal" label="Digite o Título"></v-text-field>
                            <h3>Conteúdo</h3>
                            <v-text-field class="mb-3" box v-model="templateSelected.template.body.logo.src" color="teal" label="Cole o endereço de outra imagem para a logo"></v-text-field>
                            <v-textarea class="mb-3" box label="Digite seu texto" color="teal" v-model="templateSelected.template.body.texto" persistent-hint hint="Favor utilizar pontuação de forma correta para manter o layout."></v-textarea>
                            <h3>Botão de Acesso</h3>
                            <h4>Deseja incluir?</h4>
                            <v-switch v-model="templateSelected.template.body.botao.selecionaBtn" :label="templateSelected.template.body.botao.selecionaBtn == true ? 'Sim' : 'Não'" color="teal"></v-switch>
                            <h4 v-if="templateSelected.template.body.botao.selecionaBtn">Deseja incluir mais de um link? (exemplo: para abrir em um Android ou em um iPhone)</h4>
                            <v-switch v-if="templateSelected.template.body.botao.selecionaBtn" v-model="templateSelected.template.body.botao.selecionaMultiLink" :label="templateSelected.template.body.botao.selecionaMultiLink == true ? 'Sim' : 'Não'" color="teal"></v-switch>
                            <div v-if="templateSelected.template.body.botao.selecionaBtn && !templateSelected.template.body.botao.selecionaMultiLink">
                                <v-text-field v-model="templateSelected.template.body.botao.link" color="teal" box label="Link geral"></v-text-field>
                            </div>
                            <div v-if="templateSelected.template.body.botao.selecionaBtn && templateSelected.template.body.botao.selecionaMultiLink">
                                <v-text-field v-model="templateSelected.template.body.botao.links.linkAndroid" color="teal" box label="Link para Android"></v-text-field>
                                <v-text-field v-model="templateSelected.template.body.botao.links.linkIphone" color="teal" box label="Link para iOS (iPhone)"></v-text-field>
                                <v-text-field v-model="templateSelected.template.body.botao.links.linkPc" color="teal" box label="Link geral"></v-text-field>
                            </div>
                            <v-text-field class="mb-3" box v-model="templateSelected.template.footer.contato" color="teal" label="Digite o texto do rodapé"></v-text-field>
                            <h3>Botões de redes sociais</h3>
                            <v-switch color="teal" v-model="templateSelected.template.body.redes.whatsapp.selecionado" label="Incluir WhatsApp"></v-switch>
                            <v-text-field box v-if="templateSelected.template.body.redes.whatsapp.selecionado" mask="(##)#####-####" v-model="templateSelected.template.body.redes.whatsapp.placeholder" class="pl-4" label="Digite seu telefone"></v-text-field>
                            <v-switch color="teal" v-model="templateSelected.template.body.redes.dialer.selecionado" label="Incluir Discador"></v-switch>
                            <v-text-field box v-if="templateSelected.template.body.redes.dialer.selecionado" mask="(##)#####-####" v-model="templateSelected.template.body.redes.dialer.placeholder" class="pl-4" label="Digite seu telefone"></v-text-field>
                            <v-switch color="teal" v-model="templateSelected.template.body.redes.facebook.selecionado" label="Incluir Facebook"></v-switch>
                            <v-text-field box v-if="templateSelected.template.body.redes.facebook.selecionado" class="pl-4" label="Digite o endereço de sua página" v-model="templateSelected.template.body.redes.facebook.placeholder"></v-text-field>
                            <v-switch color="teal" v-model="templateSelected.template.body.redes.email.selecionado" label="Incluir E-mail"></v-switch>
                            <v-text-field box v-if="templateSelected.template.body.redes.email.selecionado" class="pl-4" label="Digite seu e-mail" v-model="templateSelected.template.body.redes.email.placeholder"></v-text-field>
                        </div>
                        <v-btn class="ml-4" round large color="fundo" @click="atualizaTemplate">Cadastrar Layout</v-btn>
                    </v-flex>
                    <v-flex xs4>
                        <h3 class="fonte text-uppercase pt-2">Template</h3>
                        <v-card class="ma-3" width="450">
                            <div
                                is="layout"
                                style="height: 800px; overflow: auto;"
                                :head.sync="templateSelected.template.head"
                                :body.sync="templateSelected.template.body"
                                :footer.sync="templateSelected.template.footer"
                            ></div>
                        </v-card>
                    </v-flex>

                </v-layout>
            </v-card>
        </v-dialog>


        <h1 class="fonte text-uppercase mb-1">Modelos de Template</h1>
        <v-btn class="ml-0" color="fundo" @click="novoModelo = true">Novo Modelo</v-btn>
        <v-data-table
            :items="getModelos"
            :headers="headersTemplate"
            class="elevation-0 mt-3"
            hide-actions
        >
            <template v-slot:items="props">
            <td>{{ props.item.nome}}</td>
            <td class="text-xs-center">{{ convertData(props.item.createdAt) }}</td>
            <td class="text-xs-center">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" fab small flat icon color="teal" @click="editItem(props.item)">
                            <v-icon>edit</v-icon>
                        </v-btn>
                    </template>
                    <span class="title">Editar</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" fab small flat icon color="teal" @click="''">
                            <v-icon>send</v-icon>
                        </v-btn>
                    </template>
                    <span class="title">Envio</span>
                </v-tooltip>
            </td>
            </template>
        </v-data-table>

    </v-card>

</template>

<script>
import layout from './layout/layout.vue'
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment-timezone'
export default {
    components: {
        layout
    },
    data(){
        return{
            novoModelo: false,
            isDefault: false,
            editTemplate: false,
            nomeSelected: '',
            templateSelected: {
                nome: '',
                isDefault: false,
                type: '',
                template: {},
                _id: null
            },
            headersTemplate: [
                {text: 'Nome', align: 'left', sortable: false},
                {text: 'Criado em', align: 'center', sortable: false},
                {text: 'Ações', align: 'center', sortable: false}
            ],
            templateNome: '',
            template: {
                nome: '',
                type: '',
                template: {
                    head:{
                        title: "Agencia 56k",
                        color:"#00897B",
                        titulo: 'Teste',
                        logo: 'https://user-images.githubusercontent.com/7110136/29002857-9e802f08-7ab4-11e7-9c31-604b5d0d0c19.png'
                    },
                    body: {
                        logo:{
                            src:"https://www.fullstackpython.com/img/logos/vuejs-wide.png",
                            alt:"logo"
                        },
                        texto: "Desenvolvemos soluções para empresas que utilizam tecnologia para o atendimento ao cliente e necessitam de algum tipo de aplicação ou solução na área de tecnologia da informação, nas áreas de telefonia fixo e móvel.",
                        botao: {
                                selecionaBtn: false,
                                selecionaMultiLinks: false,
                                color: "#00897B",
                                label:"Abrir site",
                                link:"https://www.google.com/search?q=logo+png+vuejs&source=lnms&tbm=isch&sa=X&ved=0ahUKEwiL7qi5svXhAhUk1VkKHbTdAQAQ_AUIDigB&biw=1440&bih=828#imgrc=Zp6VNYlGNgVN6M:",
                                links: {
                                    linkAndroid: '',
                                    linkIphone: '',
                                    linkPc: ''
                                }
                        },
                        redes: {
                            whatsapp: {
                                selecionado: false,
                                placeholder: '',
                                link: '',
                            },
                            dialer: {
                                selecionado: false,
                                placeholder: '',
                                link: '',
                            },
                            facebook: {
                                selecionado: false,
                                placeholder: '',
                                link: '',
                            },
                            email: {
                                selecionado: false,
                                placeholder: '',
                                link: ''
                            },
                        },
                    },
                    footer: {
                        contato: `&copy;2018 — <strong>Vuetify</strong>`,
                    }

                }
            }
        }
    },
    computed: {
        ...mapGetters(['getModelos','getUser'])
    },
    methods: {
        ...mapActions(['saveModeloPush', 'listaModelos', 'updateModeloPush']),
        convertData(data) {
        return moment(data).format('DD/MM/YYYY HH:mm:ss')
        },
        editItem(item)
        {
            this.editTemplate = true
            this.templateSelected.template = item.template
            this.templateSelected.nome = item.nome
            this.templateSelected._id = item._id
            this.templateSelected.type = item.type
            if(this.templateSelected.type == 'default') this.templateSelected.isDefault = true
            //console.log(item)
        },
        async atualizaTemplate()
        {
            this.templateSelected.template.body.redes.whatsapp.link = 'https://api.whatsapp.com/send?phone=55' + this.templateSelected.template.body.redes.whatsapp.placeholder + '&text=salve&source=&data='
            this.templateSelected.template.body.redes.dialer.link = 'tel:+55-' + this.templateSelected.template.body.redes.dialer.placeholder
            this.templateSelected.template.body.redes.facebook.link = this.templateSelected.template.body.redes.facebook.placeholder
            this.templateSelected.template.body.redes.email.link = `mailto:${this.templateSelected.template.body.redes.email.placeholder}`
            let res = await this.updateModeloPush(this.templateSelected)

            if(res.status)
            {
                this.editTemplate = false
                this.listaModelos()
                this.$eventHub.emit('snackBar', {message:res.mensagem})
                Object.assign( this.$data, this.$options.data.apply(this) )
            }
        },
        async cadastraTemplate()
            {


                this.template.template.body.redes.whatsapp.link = 'https://api.whatsapp.com/send?phone=55' + this.template.template.body.redes.whatsapp.placeholder + '&text=salve&source=&data='
                this.template.template.body.redes.dialer.link = 'tel:+55-' + this.template.template.body.redes.dialer.placeholder
                this.template.template.body.redes.facebook.link = this.template.template.body.redes.facebook.placeholder
                this.template.template.body.redes.email.link = `mailto:${this.template.template.body.redes.email.placeholder}`
                if(this.isDefault) this.template.type = 'default'
                let res = await this.saveModeloPush(this.template)

                if(res.status)
                {
                    this.novoModelo = false
                    this.listaModelos()
                    Object.assign( this.$data, this.$options.data.apply(this) )
                    this.templateNome = ''
                    this.$eventHub.emit('snackBar', {message:res.mensagem})
                }
            },
    },
    mounted(){
        this.listaModelos()
    }
}
</script>




// WEBPACK FOOTER //
// src/components/user/push/TemplatesPush.vue